const translationRu ={
  navTel: "Телефон доверия",
  email: "Электронная почта",

  home:"Главный",

  logo1: "Центр развития профессиональной  ",
  logo2: "квалификации медицинского персонала",
  logo3: "1 - отделение ультразвуковой диагностики",
  
  kafedra: "Отделение",
  kafedra1: "История",
  kafedra2: "Профессор-преподаватели",
  kafedra3: "Портфолио профессор-преподавателей",
  kafedra4: "Информация",
  kafedra5: "Научные публикации профессор-реподавателей",

  xujjatlar: "Нормативные документы",
  xujjatlar1: "Указы Президента",
  xujjatlar2: "Приказы Минздрава",
  xujjatlar3: "Центральные команды",
  xujjatlar4: "Программы",
  xujjatlar5: "Рабочие программы",
  xujjatlar6: "Календарный план",
  xujjatlar7: "Расписание занятий",

  faoliyat: "Активность",
  faoliyat1: "Образовательная деятельность",
  faoliyat2: "Научная деятельность",
  faoliyat3: "Методическая организационная деятельность",
  faoliyat4: "Ежедневная активность",

  tinglovchilar: "Слушатели",
  tinglovchilar1: "Информация для слушателей",
  tinglovchilar2: "Видеолекции",

  news: "Новости",
  news1: "Объявления",
  news2: "Конференции",

  contact:"Контакты",

  carsuelTittle: "1 - отделение ультразвуковой диагностики",

  resultsTittle: "К здоровью нации через непрерывное образование",
  resultsCardbody1: "история ежегодного медицинского образования",
  resultsCardbody2: "региональные филиалы",
  resultsCardbody3: "академический персонал",
  resultsCardbody4: "высокотехнологичные симуляционные центры",
  resultsCardbody5: "факультеты",
  resultsCardbody6: "Академика",
  resultsCardbody7: "научных школ",
  resultsCardbody8: "Кафедры в лучших центрах и клиниках",
  resultsCardbody9: "Докторов и кандидатов наук",

  sitetittle: "Полезные ссылки",

  footerTittle: "Социальные сети:",
  footer1: "Адрес:",
  footer2: "г. Ташкент, Яшнабадский район, ул. Авиасозлар, 29",
  footer3: "Время работы:",
  footer4: "Процедура:",
  footer5: "Понедельник – Пятница, 8:30 – 14:30",
  footer6: "Выходные дни:",
  footer7: "суббота, воскресенье",


  tarixtittle: "История",
  tarix1: "Абдуфаттев Улугбек Авазжанович",
  tarix2: "Скачать",
  tarix3: "Алимов Рустам Рахимович",
  tarix4: "Скачать",
  tarix5: "Жураев Захиджон Абдужалилович",
  tarix6: "Скачать",
  tarix7: "Захидова Нодира Ахмадовна",
  tarix8: "Скачать",
  tarix9: "Исроилова Махпуза Халиловна",
  tarix10: "Скачать",
  tarix11: "Кадыров Нодирбек Абдукахарович",
  tarix12: "Скачать",
  tarix13: "Курбанов Фуркат Турдиевич",
  tarix14: "Скачать",
  tarix15: "Курбанова Вусала Видадиевна",
  tarix16: "Скачать",
  tarix17: "Розиходжаева Гулнора Ахмедовна",
  tarix18: "Скачать",
  tarix19: "Хасанов Иззатилла Гайбиллоевич",
  tarix20: "Скачать",
  tarix21: "Ходжакулов Одилжон Алишерович",
  tarix22: "Скачать",
  tarix23: "Икрамова Зулфия Тулкиновна",
  tarix24: "Скачать",
  tarix25: "Икрамова Зулфия Тулкиновна",
  tarix26: "Скачать",
  tarix27: "Нурмурадова Нодира Мурадуллаевна",
  tarix28: "Скачать",
  tarix29: "Расулова Муниса Мурмислимовна",
  tarix30: "Скачать",
  tarix31: "Фазилов Акрам",
  tarix32: "Скачать",
  tarix33: "Мирюсупов Миркосим Мирсаматович",
  tarix34: "Скачать",
  tarix35: "Ниязов Азиз Набиевич",
  tarix36: "Скачать",
  tarix37: "Сипова Гузалой Гуломидиновна",
  tarix38: "Скачать",



 
    darsTittle: "Расписание уроков",
    darsopen: "Открыть",
    darssave: "Сохранить",
    dars1: "Пренатальная ультразвуковая диагностика врожденных дефектов",
    dars2: "КЛИНИЧЕСКАЯ УЛЬТРАЗВУКОВАЯ ДИАГНОСТИКА",
    dars3: "Допплеровские технологии в акушерской практике",
    dars4: "Клиническая нейросонография",
    dars5: "Инновационные технологии в ультразвуковой маммографии",


    prezidentTittle: "Указы президента",

    ssvTittle: "Приказы Министерства здравоохранения",

    markazTittle: "Команды Центра",

    dasturTittle: "Программы",
dastur1: "Основы фетальной эхокардиографии",
dastur2: "Клиническое применение классификации BI-RADS в ультразвуковой маммографии",
dastur3: "Ультразвуковая диагностика миомы матки",
dastur4: "Клиническое применение классификации O-RADS при диагностике образований яичников",
dastur5: "Применение протоколов ультразвукового исследования FAST, BLUE, RUSH у пациентов в экстренных случаях",
dastur6: "Клиническая нейросонография",
dastur7: "Современные технологии ультразвуковой диагностики в флебологии",
dastur8: "Принципы управления ультразвуковыми диагностическими аппаратами и оптимизация эхографического изображения",
dastur9: "Технологии доплерографии в акушерской практике",
dastur10: "Фетальная эхокардиография: диагностика врожденных пороков сердца",
dastur11: "Инновационные технологии ультразвуковой маммографии",
dastur12: "Технологии ультразвуковой эластографии в клинической практике",
dastur13: "Пренатальная ультразвуковая диагностика врожденных дефектов",
dastur14: "Комплексная ультразвуковая диагностика сосудистой системы",
dastur15: "Выбранные вопросы ультразвуковой диагностики в акушерской практике",
dastur16: "Ультразвуковая диагностика и методы лечения мочекаменной болезни и её осложнений",
dastur17: "Выбранные вопросы ультразвуковой диагностики в практике урологии",
dastur18: "Основы ультразвуковой диагностики в акушерской практике",


contactTittle: "Связаться с нами",
contact1: "Адрес:",
contact2: "город Ташкент, район М.Улугбека, улица Паркент, 51",
contact3: "Контактный номер:",
contact4: "Электронная почта:",
contact5: "Рабочее время:",
contact6: "Веб-сайт:",
contact7: "Обед:",


  
workingPrograms1: "Принципы управления аппаратами ультразвуковой диагностики",
workingPrograms2: "Инновационные технологии в ультразвуковой маммографии",
workingPrograms3: "Современные технологии ультразвуковой диагностики в флебологии",
workingPrograms4: "Клиническая комплексная ультразвуковая диагностика сосудистой системы",
workingPrograms5: "Пренатальная ультразвуковая диагностика врожденных аномалий",
workingPrograms6: "Выбранные методы ультразвуковой диагностики в урологической практике",
workingPrograms7: "Клиническая ультразвуковая диагностика",
workingPrograms8: "Ультразвуковая диагностика миомы матки",
workingPrograms9: "Классификация O-RADS для диагностики опухолей яичников",
workingPrograms10: "BI-RADS ультразвуковая диагностика в маммографии",
workingPrograms11: "Ультразвуковое исследование FAST, BLUE, RUSH у пациентов с экстренными состояниями",
workingPrograms12: "Основы фетальной эхокардиографии УЗИ",
workingPrograms13: "Допплеровские технологии УЗИ в акушерской практике",
workingPrograms14: "Клиническая нейросонография УЗИ",
workingPrograms15: "Технологии эластографии в клинической ультразвуковой диагностике",

siteLink1: "Министерство здравоохранения Республики Узбекистан",
siteLink2: "Официальный веб-сайт Президента Республики Узбекистан",
siteLink3: "Единый портал интерактивных государственных услуг",

test: "Сайт находится в тестовом режиме, так как данные загружены не полностью",






}

export default translationRu